
import { Component, Vue } from "vue-property-decorator";
import HouseClass from "./HouseClass.vue";
import BoutiqueHouse from "./BoutiqueHouse.vue";
import PreferentialHouse from "./PreferentialHouse.vue";
import TyServer from "./TyServer.vue";
import ContentFooter from "./ContentFooter.vue";

@Component
export default class HomePage extends Vue {
  render() {
    return (
      <div class="home-page">
        <div class="banner">
          <div class="banner-declaration">
            <div class="dec-m">遇见生活遇见你</div>
            <div class="dec-l">雷拓尔菲地产带你走进生活</div>
          </div>
          <div class="search">
            <a-input-search
              placeholder="请输入区域、商区或小区名"
              size="large"
              enter-button="搜索"
            >
              <a-select
                slot="addonBefore"
                default-value="北京"
                style="width: 90px"
              >
                <a-select-option value="Http://">北京</a-select-option>
              </a-select>
            </a-input-search>
          </div>
        </div>
        <div class="inner-content">
          <HouseClass></HouseClass>
          <BoutiqueHouse></BoutiqueHouse>
          <PreferentialHouse></PreferentialHouse>
        </div>
        <div style="background:#fff;">
          <div class="inner-content">
            <TyServer></TyServer>
          </div>
        </div>
        <ContentFooter></ContentFooter>
      </div>
    );
  }
}
